import {FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField} from '@mui/material';
import {useFormik} from 'formik';
import React from 'react';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  countryId: Yup.string().required('country is required'),
});

function ProvinceForm({initialValues = {}, onSubmit, countriesList, disabled}, ref) {
  const formik = useFormik({
    initialValues: {
      name: '',
      countryId: '',
      ...initialValues,
    },
    validationSchema,
    onSubmit,
  });

  React.useImperativeHandle(ref, () => ({submit: () => formik.submitForm()}), [formik]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormControl sx={{mb: 2}} disabled={disabled} fullWidth>
        <InputLabel id="country-label">country</InputLabel>
        <Select
          labelId="country-category-label"
          id="countryId"
          name="countryId"
          placeholder="Select country"
          value={formik.values.countryId}
          label="Group"
          onChange={formik.handleChange}
          error={formik.touched.countryId && Boolean(formik.errors.countryId)}
        >
          {countriesList.map(country => (
            <MenuItem key={country._id} value={country._id}>
              {country.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText error>{formik.touched.countryId && formik.errors.countryId}</FormHelperText>
      </FormControl>
      <TextField
        fullWidth
        id="name"
        name="name"
        label=" Province Name"
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
        sx={{mb: 2}}
      />
    </form>
  );
}

const ForwardedRefProvinceForm = React.forwardRef(ProvinceForm);

export default ForwardedRefProvinceForm;
